import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';

import SecondaryNavigation from '../common/navigation/secondary-navigation';
import Preferences from '../moderation/preferences';
import { Products } from '../../../settings/super-admin/components/products/Products';
import SingleSignOn from '../settings/single-sign-on';
import { withAuth } from '../common/auth-checker/with-auth';
import { TeamMembers } from '../settings/team';
import { SuperAdmin } from '../../../settings/super-admin/components/SuperAdmin';

import General from './general';
import { Design } from './Design';
import Advanced from './advanced';
import CssVariables from './css-variables/css-variables';
import ConversationFeatureFlags from './conversation-feature-flags/conversation-feature-flags';

import ModalManager from 'app/scripts/components/moderation-v2/comments-and-posts/modals';
import { UserLoggedIn } from 'app/scripts/components/common/UserLoggedIn/UserLoggedIn';
import { connect } from 'react-redux';
import { fetchSpotPolicyData } from '../../../spots/spotsActions';

const displayName = 'Prefernces';

class Prefernces extends Component {
  @autobind
  afterLoggedIn(spotId) {
    this.props.fetchSpotPolicyDate(spotId);
  }

  render() {
    var { page, spot, currentUser } = this.props;
    const ssoEnabled = spot.ssoEnabled;
    var component = null,
      secondaryNavigationMenu = null;
    if (spot) {
      switch (page) {
        case 'preferences-general':
          component = <General spot={spot} currentUser={currentUser} />;
          break;
        case 'preferences-design':
          component = <Design />;
          break;
        case 'preferences-premissions':
          component = <TeamMembers currentUser={currentUser} spot={spot} />;
          break;
        case 'preferences-advanced':
          component = <Advanced spot={spot} />;

          break;
        case 'preferences-policy':
          component = <Preferences currentUser={currentUser} spot={spot} />;
          break;
        case 'preferences-single-sign-on':
          component = <SingleSignOn spot={spot} />;
          break;
        case 'preferences-super-admin-settings':
          component = (
            <SuperAdmin
              spotId={spot.id}
              enableDisqusClaim={spot.connectTypes.indexOf('disqus') > -1}
            />
          );
          break;
        case 'preferences-super-admin-products':
          component = <Products spotId={spot.id} spotName={spot.name} />;
          break;
        case 'preferences-css-variables':
          component = <CssVariables spotId={spot.id} spotName={spot.name} />;
          break;
        case 'preferences-conversation-feature-flags':
          component = <ConversationFeatureFlags spotId={spot.id} spotName={spot.name} />;
          break;
      }
      const spotId = spot.id;

      var secondaryMenuItems = [
        {
          label: 'General',
          routeName: 'preferences-general',
          navParams: { spot_id: spotId }
        },
        {
          label: 'Design',
          routeName: 'preferences-design',
          navParams: { spot_id: spotId }
        },
        {
          label: 'Team',
          routeName: 'preferences-premissions',
          navParams: { spot_id: spotId }
        },
        {
          label: 'POLICY',
          routeName: 'preferences-policy',
          navParams: { spot_id: spotId }
        },
        {
          label: 'Advanced',
          routeName: 'preferences-advanced',
          navParams: { spot_id: spotId }
        }
      ];

      if (ssoEnabled) {
        secondaryMenuItems.push({
          label: 'SINGLE SIGN ON',
          routeName: 'preferences-single-sign-on',
          navParams: { spot_id: spotId }
        });
      }

      if (currentUser.isSuperAdmin) {
        secondaryMenuItems.push({
          label: 'SYSTEM ADMIN',
          routeName: 'preferences-super-admin-settings',
          navParams: { spot_id: spotId }
        });
        secondaryMenuItems.push({
          label: 'CSS Variables',
          routeName: 'preferences-css-variables',
          navParams: { spot_id: spotId }
        });
        secondaryMenuItems.push({
          label: 'Conversation Feature Flags',
          routeName: 'preferences-conversation-feature-flags',
          navParams: { spot_id: spotId }
        });
      }
      secondaryNavigationMenu = (
        <SecondaryNavigation title="Settings" selected={page} menuItems={secondaryMenuItems} />
      );
    }

    return (
      <div className="preferences">
        {secondaryNavigationMenu}
        {component}
        <ModalManager />
        <UserLoggedIn handler={this.afterLoggedIn} />
      </div>
    );
  }
}

Prefernces.propTypes = {
  page: PropTypes.string.isRequired,
  spotId: PropTypes.string.isRequired,
  spot: PropTypes.object,
  currentUser: PropTypes.object
};

Prefernces.displayName = displayName;

function mapDispatchToProps(dispatch) {
  return { fetchSpotPolicyDate: spotId => dispatch(fetchSpotPolicyData(spotId)) };
}

export default connect(undefined, mapDispatchToProps)(withAuth(Prefernces));
